import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import Button from '../../elements/Button';
import Text from '../../fields/Text';
import styles from './styles.scoped.css';
import { Grid, MultiSelect, Text as TextMantine, Tooltip } from '@mantine/core';
import { useSelector } from 'react-redux';
import Select from '../../fields/SelectBox/Select';
import IconInfo from '../../icons/IconInfo';
export default function RoleForm({
  change = () => { },
  handleSubmit = () => { },
  initialValues = {},
}) {
  const { dataPermission } = useSelector((s) => s.role);
  const { values } = useSelector((state) => state.form.formPermissionUser);

  const inputPermissionsRole = {
    label: 'Nama Role',
    placeholder: 'Nama Role',
  };
  const inputUserType = {
    label: 'Tipe User',
    placeholder: 'Pilih Tipe User',
    data: [
      { value: 'superadmin', label: 'CRUD + Download + Upload' },
      { value: 'admin', label: 'CRUD' },
    ]
  };

  const inputPropsPermission = {
    label: 'Tipe Permissions',
    placeholder: 'Pilih Tipe Permissions',
    data: dataPermission.dataOptions,
  };
  const type = Object.keys(initialValues).length > 0 ? 'edit' : 'add';

  const onSubmit = async (e) => {
    e.preventDefault();
    handleSubmit(values);
  };

  const validation = () =>
    values?.role !== '' &&
    values?.userType !== '' &&
    values?.permissions?.length > 0;

  return (
    <form onSubmit={onSubmit}>
      <p>Form {type === 'edit' ? 'Ubah' : 'Tambah'} Role</p>
      <br />
      <div className={styles.desc}>
        {type === 'edit'
          ? 'Berikut ini adalah form yang digunakan untuk merubah data '
          : 'Berikut ini adalah form yang digunakan untuk menambah data '}{' '}
        <b>Role.</b> Pastikan data yang anda inputkan sudah sesuai. Semua
        parameter pada <b>form ini wajib diisi.</b>
      </div>
      <br />
      <Field
        component={Text}
        inputProps={inputPermissionsRole}
        name="role"
        required={true}
      />
      <Grid columns={10}>
        <Grid.Col span={9}>
          <Field
            className={styles.inputSelect}
            component={Select}
            data={inputUserType.data}
            inputProps={inputUserType}
            name="userType"
            placeholder={inputUserType.placeholder}
            required={true}
          />
        </Grid.Col>
        <Grid.Col mt={30} span={'content'}>
          <Tooltip
            bg="white"
            c="#25282B"
            label={
              <div>
                <strong>Tipe User:</strong>
                <ul style={{ marginLeft: '-1rem' }}>
                  <li>
                    <TextMantine fz={12}>
                      <strong>CRUD + Download + Upload:
                      </strong>{' '}
                      dapat mengunggah, unduh, dan akses semua
                      halaman. Dapat mengubah data pangkalan.
                    </TextMantine>
                  </li>
                  <li>
                    <TextMantine fz={12}><strong>CRUD:</strong> dapat mengakses beberapa halaman.
                    </TextMantine></li>
                </ul>
              </div>
            }
            multiline
            position="left"
            styles={{
              tooltip: {
                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                padding: '.75rem .9rem'
              }
            }}
            w="25.75rem"
            withArrow
            zIndex={999999}
          >
            <div><IconInfo type={'info'} /></div>
          </Tooltip>
        </Grid.Col>
      </Grid>

      <MultiSelect
        data={inputPropsPermission.data}
        defaultValue={initialValues.permissions}
        label={inputPropsPermission.label}
        name="permissions"
        onChange={(value) => {
          change('permissions', value);
        }}
        placeholder={inputPropsPermission.placeholder}
        styles={{
          label: { fontWeight: '600', fontSize: '1rem' },
        }}
        withAsterisk={true}
      />
      <br />
      <div className={styles.btnSaveContainer}>
        <Button
          className={styles.btnSave}
          disabled={!validation()}
          fullWidth
          style={'blue'}
          type="submit"
        >
          Simpan
        </Button>
      </div>
    </form>
  );
}

RoleForm.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  isOpen: PropTypes.bool,
  type: PropTypes.string,
};
